import {useEffect, useRef} from 'react';
import {useSearchParams} from '../../../router/compat';
import {useAuth} from '../../auth/context/AuthContext';
import {getDefaultFilters} from '../constants/defaultFilters';

const FILTER_PARAMS = ['status', 'priority', 'assignee_id'];

export function useDefaultFilters(): void {
	const [searchParams, setSearchParams] = useSearchParams();
	const {status, user} = useAuth();
	const hasRunRef = useRef(false);

	useEffect(() => {
		if (hasRunRef.current) return;
		if (status !== 'authenticated' || !user) return;

		hasRunRef.current = true;

		// Don't redirect if any filter param is already present
		const hasFilterParams = FILTER_PARAMS.some(p => searchParams.has(p));
		if (hasFilterParams) return;

		// Don't redirect if the user explicitly cleared filters
		if (searchParams.has('view')) return;

		const defaults = getDefaultFilters(user.role, user.id);
		const next = new URLSearchParams(searchParams);
		defaults.status.forEach(v => next.append('status', v));
		defaults.priority.forEach(v => next.append('priority', v));
		defaults.assignee_id.forEach(v => next.append('assignee_id', v));

		setSearchParams(next, {replace: true});
	}, [status, user, searchParams, setSearchParams]);
}
